import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { updateConfig as _updateConfig } from "@/api/configurationlist";
export default {
  name: "",
  props: ['deviceSn', 'deviceDid'],
  data: function data() {
    return {
      dialogVisible: false,
      serial: {},
      baudrateList: ['110', '134', '150', '200', '300', '600', '1200', '1800', '2400', '4800', '9600', '19200', '38400', '57600', '115200'],
      customValue: "",
      customValue2: "",
      databitsList: ['6', '7', '8'],
      stopBitsList: ['1', '2'],
      rules: {},
      parityList: [{
        label: 'None',
        value: 'N'
      }, {
        label: 'Odd',
        value: 'O'
      }, {
        label: 'Even',
        value: 'E'
      }, {
        label: 'Mark',
        value: 'M'
      }, {
        label: 'Space',
        value: 'S'
      }],
      flow_ctrlList: [{
        label: 'None',
        value: 'N'
      }, {
        label: 'Xon/Xoff',
        value: 'X'
      }]
    };
  },
  methods: {
    show: function show(serial) {
      this.dialogVisible = true;
      this.serial = serial;
      console.log(this.serial);
    },
    confirmSerial: function confirmSerial() {},
    databitsChange: function databitsChange() {
      var _this = this;

      this.customValue = this.serial.data_bits;
      this.$nextTick(function () {
        // data_bits_custom获得焦点
        _this.$refs.data_bits_custom.focus();
      });
    },
    stopbitsChange: function stopbitsChange() {
      var _this2 = this;

      this.customValue2 = this.serial.stop_bits;
      this.$nextTick(function () {
        // data_bits_custom获得焦点
        _this2.$refs.stop_bits_custom.focus();
      });
    },
    customInput: function customInput() {
      this.databitsList.push(this.customValue);
      this.serial.data_bits = this.customValue;
    },
    customInput2: function customInput2() {
      this.stopBitsList.push(this.customValue2);
      this.serial.data_bits = this.customValue2;
    },
    updateConfig: function updateConfig() {
      var _this3 = this;

      _updateConfig(this.deviceSn, this.deviceDid, [{
        config: 'smartele',
        section: this.serial.name,
        action: 0,
        index: [0],
        options: {
          baudrate: this.serial.baudrate,
          data_bits: this.serial.data_bits,
          stop_bits: this.serial.stop_bits,
          parity: this.serial.parity,
          flow_ctrl: this.serial.flow_ctrl,
          enable_frame: this.serial.enable_frame ? '1' : '0',
          timeout: this.serial.timeout,
          frame_len: this.serial.frame_len
        }
      }]).then(function (res) {
        if (res.data.data.mess === 0) {
          _this3.$message({
            message: '保存成功',
            type: 'success'
          });

          _this3.dialogVisible = false;

          _this3.$emit('refresh');
        } else {
          _this3.$message({
            message: '保存失败',
            type: 'error'
          });
        }
      });
    }
  }
};